The partner's unique identifier for the position.

This identifier is used to look up all reasons why the position was not posted on SEEK.
